import { IScenarioDB } from './interfaces';

export const BREAKING_WAYS_2_MINIMUM_COIN_SPIN_ROWS = 4;

const BREAKING_WAYS_2_MODEL_IDS = new Set([
  'ff010-breaking-ways-2',
  'ff011-breaking-buffalo-2',
]);

export const getBreakingWaysMinimumCoinSpinRows = (modelId: string) =>
  BREAKING_WAYS_2_MODEL_IDS.has(modelId)
    ? BREAKING_WAYS_2_MINIMUM_COIN_SPIN_ROWS
    : undefined;

export const ensureMinimumCoinSpinRows = <T>(
  window: Array<Array<T | null>>,
  minimumRows: number,
): Array<Array<T | null>> =>
  window.map((reel) => reel.length >= minimumRows
    ? reel
    : [...reel, ...Array<T | null>(minimumRows - reel.length).fill(null)]);

export const prepareBreakingWaysScenariosForRequest = (
  scenarios: IScenarioDB[],
  minimumCoinSpinRows?: number,
) =>
  scenarios.map((scenario) => {
    const coinSpins = scenario.otherData?.coinSpins;
    if (!Array.isArray(coinSpins)) {
      return scenario;
    }

    if (coinSpins.length > 0) {
      if (!minimumCoinSpinRows) { return scenario; }
      const normalizedCoinSpins = coinSpins.map((window) =>
        ensureMinimumCoinSpinRows(window, minimumCoinSpinRows));
      const changed = normalizedCoinSpins.some((window, windowIndex) =>
        window.some((reel, reelIndex) => reel !== coinSpins[windowIndex][reelIndex]));
      if (!changed) { return scenario; }
      return {
        ...scenario,
        otherData: {
          ...scenario.otherData,
          coinSpins: normalizedCoinSpins,
        },
      };
    }

    const {
      coinSpins: _emptyCoinSpins,
      coinSpinIndex: _emptyCoinSpinIndex,
      ...otherData
    } = scenario.otherData;

    return {
      ...scenario,
      otherData,
    };
  });
